// extracted by mini-css-extract-plugin
export var alertIcon = "_oh-0";